import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import content from '../content';
import useWindowPosition from '../hook/useWindowPosition';

export default function Work() {
  const animated = useWindowPosition('header', 0.6);
  return (
    <>

      <div
        className="my-10 flex justify-center items-center flex-col"
        style={{
          background: '#FEFEFE',
        }}
      >
        <h1 className="text-5xl font-dosis font-bold mb-4">{content.work.title}</h1>
        <div className="flex flex-col md:flex-row justify-between items-center w-11/12 ">
          <LazyLoadImage
            effect="blur"
            placeholderSrc={content.work.imgPlaceholder}
            src={content.work.img}
            alt="phone prototype"
            className="m-10 transtion duration-2000 ease-in-out z-10  md:w-3/5 w-4/5"
          />
          <div>

            <div
              className="transtion duration-2000 ease-in-out p-10 max-w-xl lg:max-w-3xl rounded-lg hidden md:block"
              style={{
                border: '1px solid #e5ecf9',
                transform: animated
                  ? 'translate(-10%, 0%) rotate3d(0.540, -0.95, 0, 22deg) rotateZ(7deg)'
                  : '',
                boxShadow:
                  '35px 50px 90px -25px rgba(50, 50, 95, 0.5), 20px 35px 75px -35px rgba(0, 0, 0, 0.5)',
              }}
            >
              <ProjectDetail />
            </div>
            <div className="flex justify-center items-center md:hidden">
              <ProjectDetail />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const ProjectDetail = () => {
  const animated = useWindowPosition('header', 0.6);
  return (
    <div>
      <h1
        className={` ${animated ? '' : 'translate-y-10 opacity-0'
          }   transform transition duration-2000 inline-block m-4  font-dosis text-xl font-bold`}
      >
        {content.work.projectName}
      </h1>
      <p
        className={`${animated ? '' : 'translate-y-10 opacity-0'
          }  transform transition duration-2000 inline-block w-11/12 m-4  text-xl font-dosis`}
      >
        {content.work.desc}
      </p>
      <button
        className={`${animated ? '' : 'translate-y-10 opacity-0'
          } transform transition duration-2000  px-20 py-3 m-4 bg-black flex justify-around text-white rounded-lg shadow-2xl`}
      >
        <a href="https://radiant-academy.vercel.app/" target="_new">
        <h5><i class="fas fa-rocket"></i> Website</h5>
        </a>
      </button>
    </div>
  );
};
